<template>
  <div class="liquor-browser">
    <Header active="/liquor/browser" />
    <HeaderSelect active="browser" :list="headerSelectArray" />
    <SearchSelect :options.sync="options" @change="onChange" :rules="[[3,4],[5,7],[5,6],[7,6]]" />
    <LiquorList :list="liquorArray" />
    <Sticky />
  </div>
</template>

<script>
import Header from "@/components/liquor/Header";
import HeaderSelect from "@/components/liquor/HeaderSelect";
import SearchSelect from "@/components/liquor/SearchSelect";
import LiquorList from "@/components/liquor/LiquorList";
import Sticky from "@/components/liquor/Sticky";

import pinyin4js from "pinyin4js";

export default {
  name: "LiquorBrowser",
  components: {
    Header,
    HeaderSelect,
    SearchSelect,
    LiquorList,
    Sticky
  },
  data() {
    return {
      pageNum: 1,
      numPerPage: 50,
      pageCount: 0,
      headerSelectArray: [
        {
          name: "商品一览",
          link: "/liquor/browser",
          active: true
        },
        {
          name: "配餐配酒",
          link: "/liquor/food-wine",
          active: false
        },
        {
          name: "品鉴美学",
          link: "/liquor/tasting",
          active: false
        }
      ],
      liquorArray: [],
      options: [
        {
          level: 3,
          label: "种类",
          value: [],
          up: true,
          show: true
        },
        {
          level: 4,
          label: "小类",
          value: [],
          up: true,
          show: true
        },
        {
          level: 5,
          label: "国家",
          value: [],
          up: true,
          show: true
        },
        {
          level: 6,
          label: "品牌",
          value: [],
          up: true,
          show: true
        },
        {
          level: 7,
          label: "产区",
          value: [],
          up: true,
          show: true
        },
        {
          level: 8,
          label: "葡萄品种",
          value: [],
          up: true,
          show: true
        },
        {
          level: 9,
          label: "级别",
          value: [],
          up: true,
          show: true
        }
      ]
    };
  },
  created() {
    this.init();
  },
  methods: {
    async loadData1() {
      const response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorLabel",
        methodName: "retrieve",
        params: {
          pageNum: 1,
          numPerPage: 1000
        }
      });
      // 种类
      const actived = this.$route.query["3"]
        ? this.$route.query["3"].split(",")
        : [];
      this.options[0].value = [
        {
          level: 3,
          label: "全部",
          value: "全部",
          active: actived.length == 0,
          type: "all",
          show: true,
          parent: []
        },
        ...this.util.sortByPinyin(
          response.results
            .filter(e => e.level === 3)
            .map(e => {
              return {
                level: 3,
                label: e.label,
                value: e.value,
                active: actived.indexOf(e.value) >= 0,
                type: "tag",
                show: true
              };
            }),
          "label"
        )
      ];
      // 小类
      this.options[1].value = [
        {
          level: 4,
          label: "全部",
          value: "全部",
          active: true,
          type: "all",
          show: true,
          parent: []
        },
        ...this.util.sortByPinyin(
          response.results
            .filter(e => e.level === 4)
            .map(e => {
              return {
                level: 4,
                label: e.label,
                value: e.value,
                active: false,
                type: "tag",
                show: true,
                parent: [e.parent]
              };
            }),
          "label"
        )
      ];
    },
    async loadData2() {
      const response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorCommodity",
        methodName: "retrieve",
        params: {
          pageNum: 1,
          numPerPage: 1000
        }
      });

      const set = new Set(
        response.results.filter(e => e.country).map(e => e.country)
      );

      console.log(set);
      // 国家
      this.options[2].value = [
        {
          level: 5,
          label: "全部",
          value: "全部",
          active: true,
          type: "all",
          show: true,
          parent: []
        },
        ...this.util.sortByPinyin(
          Array.from(set).map(e => {
            return {
              level: 5,
              label: e,
              value: e,
              active: false,
              type: "tag",
              show: true
            };
          }),
          "label"
        )
      ];
    },
    async loadData3() {
      const response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorCommodity",
        methodName: "retrieve",
        params: {
          pageNum: 1,
          numPerPage: 1000
        }
      });
      const set = new Set(
        response.results.filter(e => e.brand).map(e => e.brand)
      );

      // 品牌
      const actived = this.$route.query["6"]
        ? this.$route.query["6"].split(",")
        : [];
      this.options[3].value = [
        {
          level: 6,
          label: "全部",
          value: "全部",
          active: actived.length == 0,
          type: "all",
          show: true,
          parent: []
        },
        ...this.util.sortByPinyin(
          Array.from(set).map(e => {
            return {
              level: 6,
              label: e,
              value: e,
              active: actived.indexOf(e) >= 0,
              type: "tag",
              show: true,
              parent: []
            };
          }),
          "label"
        )
      ];
    },
    async loadData4() {
      const response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorCommodity",
        methodName: "retrieve",
        params: {
          pageNum: 1,
          numPerPage: 1000
        }
      });

      const set = new Set(
        response.results.filter(e => e.area).map(e => e.area)
      );

      // 产区
      this.options[4].value = [
        {
          level: 7,
          label: "全部",
          value: "全部",
          active: true,
          type: "all",
          show: true,
          parent: []
        },
        ...this.util.sortByPinyin(
          Array.from(set).map(e => {
            return {
              level: 7,
              label: e,
              value: e,
              active: false,
              type: "tag",
              show: true,
              parent: [e]
            };
          }),
          "label"
        )
      ];
    },
    async loadData5() {
      const response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorCommodity",
        methodName: "retrieve",
        params: {
          pageNum: this.pageNum,
          numPerPage: this.numPerPage
        }
      });

      // this.liquorArray = response.results;

      this.pageCount = response.page.pageCount;

      this.options[5].value = [
        {
          level: 8,
          label: "全部",
          value: "全部",
          active: true,
          type: "all",
          show: true,
          parent: []
        },
        ...Array.from(
          new Set(response.results.map(e => e.grapeVariety.split("、")).flat())
        )
          .filter(e => e)
          .map(e => {
            return {
              level: 8,
              label: e,
              value: e,
              active: false,
              type: "tag",
              show: true,
              parent: []
            };
          })
      ];

      this.options[6].value = [
        {
          level: 9,
          label: "全部",
          value: "全部",
          active: true,
          type: "all",
          show: true,
          parent: []
        },
        ...Array.from(new Set(response.results.map(e => e.level)))
          .filter(e => e)
          .map(e => {
            return {
              level: 9,
              label: e,
              value: e,
              active: false,
              type: "tag",
              show: true,
              parent: []
            };
          })
      ];
    },
    async loadData6() {},
    async loadData7() {},
    async loadData8() {},
    async loadData9() {},
    async init() {
      await this.loadData1();
      this.loadData2();
      this.loadData3();
      this.loadData4();
      this.loadData5();
      this.onChange();
      window.addEventListener("scroll", this.handleScroll, true);
    },
    async handleScroll(e) {
      // console.log(e.target.documentElement.scrollTop);
      // console.log(e.target.documentElement.clientHeight);
      // console.log(e.target.documentElement.scrollHeight);
      const html = e.target.documentElement;

      if (html.scrollTop + html.clientHeight === html.scrollHeight) {
        this.pageNum += 1;
        if (this.pageNum <= this.pageCount) {
          const response = await this.ajax.doRest({
            packageName: "es",
            className: "search",
            methodName: "commodity",
            params: {
              list: result,
              form: this.liquorArray.length
            }
          });
          this.liquorArray = this.liquorArray.concat(response.results);
        } else {
          // this.$message("到底了！");
        }
      }
    },
    async onChange(e) {
      let result = [];
      this.options.forEach(e => {
        e.value
          .filter(e => e.type === "tag")
          .forEach(e => {
            if (e.active) {
              result.push(e);
            }
          });
      });

      console.log(result);

      const response = await this.ajax.doRest({
        packageName: "es",
        className: "search",
        methodName: "commodity",
        params: {
          list: result
        }
      });

      console.log(response);

      this.liquorArray = response.results;
    }
  }
};
</script>

<style lang="scss">
.liquor-browser {
  width: 100%;
  margin-top: 160px;
  // overflow-x: hidden;
}
</style>

<style lang="scss" scoped>
.liquor-browser {
  .liquor-header-parent {
    background: rgba(0, 0, 0, 1);
  }
}
</style>